/**
 * @author：
 * @update：
 * @description：
 **/
import { mealType } from "@/utils/enum";

import {
  orderGet,
  orderSeach,
  orderAgreements,
  dealManageExpress,
} from "@/api/order";
import { fileEcho } from "@/api/url";
import { imageOrdersDetail, invoiceQueryByCode } from "@/api/package";
import download from "downloadjs";
import express_com from "@/utils/express_com";
import musicIcon from "@/assets/images/upload/audioIcon.png";
export default {
  data() {
    return {
      mealType,
      musicIcon,
      id: "", //url id
      loading: true,
      tableData: {
        invoiceStatus: "",
        status: "",
        type: "",
        shopName: "",
        phone: "",
        menuType: "",
        price: "",
        paidTime: "",
        store: {
          name: "",
          contact: {
            phone: "",
          },
        },
        delivery: {
          contact: {
            phone: "",
          },
        },
        invoice: {},
        settleOrder: {
          payType: "",
          orderNo: "",
        },
        userInfo: {
          nickname: "",
          mobile: "",
        },
        cancelReason: "",
        imgLen: 0,
        refundReason: "",
      },
      tableDataLoc: fileEcho,
      statusText: "", //交易状态文字
      endTime: "",
      day: 0,
      hr: 0,
      min: 0,
      sec: 0,
      download: "",
      coms: Object.freeze(express_com),
      expressDialog: false, //查看物流弹框
      expressCompany: "", //物流公司
      expressNumber: "", //物流单号
      activities: [], //物流信息数组
      invoiceExpress: "",
      invoiceNewData: {},
    };
  },
  // 自定义方法
  methods: {
    //获取数据
    getList() {
      this.$ajax.get(imageOrdersDetail(this.id)).then(
        (res) => {
          this.loading = false;
          if (res.status === 200) {
            // 成功了
            const {
              id,
              type,
              shopName,
              phone,
              createTime,
              payMode,
              price,
              code,
              payTime,
              orderNo,
              menuType,
              cancelReason,
              refundReason,
              photoList,
            } = res.data.data;
            this.tableData = {
              ...this.tableData,
              ...res.data.data,
            };
            // this.tableData.orderNo = code;
            this.tableData.orderNo = id;
            this.tableData.type = type;
            this.tableData.shopName = shopName;
            this.tableData.phone = phone;
            this.tableData.createdDate = createTime;
            this.tableData.settleOrder.payType = payMode;
            this.tableData.settleOrder.orderNo = orderNo;
            this.tableData.orderItems = photoList;
            this.tableData.price = price;
            this.tableData.paidTime = payTime;
            this.tableData.menuType = menuType;
            this.tableData.cancelReason = cancelReason;
            this.tableData.refundReason = refundReason;
            this.tableData.imgLen = photoList.length;
            this.loading = false;
            // this.countdown();
            // if (res.data.status == 'TOPAY') {
            //     this.statusText = '等待买家付款';
            //     this.endTime = res.data.settleOrder.expireTime;
            // } else if (res.data.status == 'TOSHIP') {
            //     this.statusText = '买家已付款'
            // } else if (res.data.status == 'PARTSHIPPED') {
            //     this.statusText = '卖家部分发货'
            // } else if (res.data.status == 'SHIPPED') {
            //     this.statusText = '卖家已发货';
            //     this.endTime = res.data.autoReceiptConfirmTime;
            // } else if (res.data.status == 'CONFIRMED') {
            //     this.statusText = '已完成'
            // } else if (res.data.status == 'REFUNDED') {
            //     this.statusText = '已退款'
            // } else if (res.data.status == 'CANCELED') {
            //     this.statusText = '交易关闭'
            // }
            // for (let i = 0; i < this.coms.length; i++) {
            //     if (res.data.invoices != undefined && res.data.invoices.length > 0) {
            //         if (this.coms[i].code == res.data.invoices[0].expressCompany) {
            //             this.invoiceExpress = this.coms[i].com
            //         }
            //     }
            // }
          }
        },
        (err) => {
          console.log(err);
          this.loading = false;
        }
      );

      // this.$ajax.get(imageOrdersDetail(this.id)).then((res) => {
      //     console.log('res-------2222-----',res);
      //     if(res.data.code == 200){

      //     }
      //     this.tableData = res.data.data;

      // }, (err) => {
      //     console.log(err);
      // })
    },
    //未付款倒计时
    countdown() {
      // 定义结束时间戳
      const end = Date.parse(new Date(this.endTime));
      // 定义当前时间戳
      const now = Date.parse(new Date());
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.day = 0;
        this.hr = 0;
        this.min = 0;
        this.sec = 0;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      const msec = end - now;
      let day = parseInt(msec / 1000 / 60 / 60 / 24); //算出天数
      let hr = parseInt((msec / 1000 / 60 / 60) % 24); //算出小时数
      let min = parseInt((msec / 1000 / 60) % 60); //算出分钟数
      let sec = parseInt((msec / 1000) % 60); //算出秒数
      //给数据赋值
      this.day = day;
      this.hr = hr > 9 ? hr : "0" + hr;
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      //定义this指向
      const that = this;
      // 使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
      setTimeout(function () {
        that.countdown();
      }, 1000);
    },
    agreementsBtn(item) {
      console.log(item);
      this.$ajax.get(orderAgreements(item.id)).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            // window.location.href = this.tableDataLoc + res.data.content.location;//在本页面打开
            // window.open(this.tableDataLoc + res.data.content.location, "_blank", '');//在新页面打开
            let row = res.data.content;
            let fileName = row.filename.lastIndexOf("."); //取到文件名开始到最后一个点的长度
            let fileNameLength = row.filename.length; //取到文件名长度
            let fileFormat = row.filename.substring(
              fileName + 1,
              fileNameLength
            ); //截取文件的后缀名。
            console.log(fileFormat, 111111);
            if (fileFormat == "xls" || fileFormat == "xlsx") {
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = this.tableDataLoc + row.location;
              link.setAttribute("download", row.filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link); // 下载完成移除元素
            } else {
              download(this.tableDataLoc + row.location);
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //查看物流弹框
    expressBtn(item) {
      this.expressDialog = true;
      console.log(item);
      console.log(this.coms);
      for (let i = 0; i < this.coms.length; i++) {
        if (this.coms[i].code == item.expressRecord.company) {
          this.expressCompany = this.coms[i].com;
          this.expressNumber = item.expressRecord.number;
        }
      }
      this.$ajax
        .post(dealManageExpress, {
          com: item.expressRecord.company,
          num: item.expressRecord.number,
        })
        .then(
          (res) => {
            this.activities = res.data.data;
            console.log(res.data);
            // this.$message({
            //     type: 'success',
            //     message: '删除成功!'
            // });
          },
          (err) => {
            // this.$message.error('删除失败');
            console.log(err);
          }
        );
    },
    // 发票详情
    invoiceDetail(code) {
      this.$ajax.get(invoiceQueryByCode(code)).then((res) => {
        if (res.data.code == 200) {
          console.log(res.data.data);
          this.invoiceNewData = res?.data?.data || {};
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
  // 数据观察监听
  watch: {},
  // 计算数据
  computed: {
    payText() {
      return ["已完成", "待付款", "已取消", "已退款", "", "", "待审核"][
        this.tableData.type
      ];
    },
  },
  // 组件数据创建之前
  beforeCreate() {},
  // 组件数据创建完成
  created() {
    if (this.$route.query.id != undefined) {
      this.id = window.atob(this.$route.query.id); //详情的id
      this.getList();
    }
    if (this.$route.query.code != undefined) {
      this.invoiceDetail(this.$route.query.code);
    }
  },
  // 组件挂载完成之前
  beforeMount() {},
  // 组件挂载完成
  mounted() {},
  // 组件即将销毁
  beforeDestroy() {},
  // 组件销毁
  destroyed() {},
  // 组件激活
  activated() {},
  // 组件冻结
  deactivated() {},
};
